/**
 * 网络请求配置
 */
import axios from "axios";
import {
  ElMessage 
} from 'element-plus';


// 创建axios实例
const service = axios.create({
  timeout: 60000, // 请求超时时间
  baseURL: "/api",
  // baseURL: "/api",
  withCredentials: false,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-cache"
  },
  // baseURL: "http://geek.itheima.net/v1_0"
});

service.defaults.headers["Content-Type"] = "application/json";

/**
 * http request 拦截器
 */
service.interceptors.request.use(
  (config) => {
    const token = localStorage.token
    // storage.get(ACCESS_TOKEN);
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * http response 拦截器
 */
service.interceptors.response.use(
  (response) => {
    if (response.data.code === 401) {
      // ElMessage .warning("登录已过期")
    } else if (response.data.code === 500) {
      // ElMessage .error(
      //   response.data.msg === ("" || null) ?
      //   "系统未知错误，请联系管理员" :
      //   response.data.msg
      // );
    }
    return response.data;
  },
  (error) => {
    const errData = error ?.response.data;
    if (error.response.status === 401) {
      // ElMessage .error("登录已过期");
    } else {
      // ElMessage .error(errData ?.msg || "系统未知错误，请联系管理员");
    }
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
  service.defaults.headers["Content-Type"] = "application/json";
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params,
      })
      .then((response) => {
        // landing(url, params, response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
  service.defaults.headers["Content-Type"] = "application/json";
  return new Promise((resolve, reject) => {
    service.post(url, data).then(
      (response) => {
        //关闭进度条
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        msag(err);
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  service.defaults.headers["Content-Type"] = "multipart/form-data";
  return new Promise((resolve, reject) => {
    service.put(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        msag(err);
        reject(err);
      }
    );
  });
}

//统一接口处理，返回数据
export default function (fecth, url, param) {
  let _data = "";
  return new Promise((resolve, reject) => {
    switch (fecth) {
      case "get":
        console.log("begin a get request,and url:", url);
        get(url, param)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            console.log("get request GET failed.", error);
            reject(error);
          });
        break;
      case "post":
        post(url, param)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            console.log("get request POST failed.", error);
            reject(error);
          });
        break;
      default:
        break;
    }
  });
}

//失败提示
// function msag(err) {
//   if (err && err.response) {
//     switch (err.response.status) {
//       case 400:
//         alert(err.response.data.error.details);
//         break;
//       case 401:
//         alert("未授权，请登录");
//         break;

//       case 403:
//         alert("拒绝访问");
//         break;

//       case 404:
//         alert("请求地址出错");
//         break;

//       case 408:
//         alert("请求超时");
//         break;

//       case 500:
//         alert("服务器内部错误");
//         break;

//       case 501:
//         alert("服务未实现");
//         break;

//       case 502:
//         alert("网关错误");
//         break;

//       case 503:
//         alert("服务不可用");
//         break;

//       case 504:
//         alert("网关超时");
//         break;

//       case 505:
//         alert("HTTP版本不受支持");
//         break;
//       default:
//     }
//   }
// }

/**
 * 查看返回的数据
 * @param url
 * @param params
 * @param data
 */
// function landing(url, params, data) {
//   if (data.code === -1) {
//   }
// }